import {Component, OnInit} from '@angular/core';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import {SidebarService} from '../../../shared/services/sidebar.service';
import { ClientsService } from '../clients.service';
import { LicenseTier, LicenseTierModel } from '../../../models/license-tier/license-tier.model';
import { ClientEnum, ClientModel } from '../../../models/survey/survey.model';
import * as _ from 'lodash';

@Component({
  selector: 'app-new-client',
  templateUrl: './new-client.component.html',
  styleUrls: ['./new-client.component.less']
})
export class NewClientComponent implements OnInit {

  licenseTiers: LicenseTierModel[];
  clientForm: FormGroup;
  dropdownLabel: string;
  licenseTierId?: number;
  isAllowImportTypeForm = true;
  isAllowImportSurveyMonkey = true;
  clientId: number;
  showDeleteClientConfirm = false;
  loader = false;
  isInternal = false;
  isLicenseTierInternal = false;

  constructor(protected clientsService: ClientsService,
              protected fb: FormBuilder,
              protected sidebarService: SidebarService,
              protected router: Router) {
    this.clientForm = this.fb.group({
      'active': [true],
      'name': [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
      'expiryDate': [null], 
      'allowImportTypeForm': [true],
      'typeFormToken': [null, Validators.compose([Validators.required, Validators.maxLength(255)])], 
      'surveyMonkeyActivated': [true],
      'surveyMonkeyToken': [null, Validators.compose([Validators.required, Validators.maxLength(255)])], 
    });

    this.clientsService.getAllLicenseTier().subscribe(
        (response) => {
          this.licenseTiers = response;
          this.licenseTiers = _.filter(response, function(o) {
            return o.name !== ClientEnum.INTERNAL;
          });
          const licenseTier = this.licenseTiers.find(m => {
              return m.name === LicenseTier.BASIC;
          })
          if (licenseTier) {
            this.licenseTierId = licenseTier.id;
            this.isAllowImportSurveyMonkey = licenseTier.allowImportSurveyMonkey;
            this.isAllowImportTypeForm = licenseTier.allowImportTypeForm;
            if (!this.isAllowImportTypeForm) {
                this.clientForm.controls['typeFormToken'].clearValidators();
                this.clientForm.controls['typeFormToken'].updateValueAndValidity();
            }
            if (!this.isAllowImportSurveyMonkey) {
                this.clientForm.controls['surveyMonkeyToken'].clearValidators();
                this.clientForm.controls['surveyMonkeyToken'].updateValueAndValidity();
            }
          }
        },
        (error) => {
        }
    );
  }

  ngOnInit() {
    if (!AuthTokenService.isAdmin()) {
      this.router.navigate(['/surveys']);
    }

    this.dropdownLabel = LicenseTier.BASIC;

    this.clientForm.get('allowImportTypeForm').valueChanges.subscribe(val => {
        if (val) {
          this.clientForm.controls['typeFormToken'].setValidators([Validators.required, Validators.maxLength(255)]);
          this.clientForm.controls['typeFormToken'].enable({ emitEvent: false });
        } else {
          this.clientForm.controls['typeFormToken'].clearValidators();
          this.clientForm.controls['typeFormToken'].disable({ emitEvent: false });
        }
        this.clientForm.controls['typeFormToken'].updateValueAndValidity();
    });

    this.clientForm.get('surveyMonkeyActivated').valueChanges.subscribe(val => {
        if (val) {
          this.clientForm.controls['surveyMonkeyToken'].setValidators([Validators.required, Validators.maxLength(255)]);
          this.clientForm.controls['surveyMonkeyToken'].enable({ emitEvent: false });
        } else {
          this.clientForm.controls['surveyMonkeyToken'].clearValidators();
          this.clientForm.controls['surveyMonkeyToken'].disable({ emitEvent: false });
        }
        this.clientForm.controls['surveyMonkeyToken'].updateValueAndValidity();
    });
  }

  onSave() {
    if (this.clientForm.valid) {
      let client = new ClientModel();
      client.active = this.clientForm.controls['active'].value;
      client.name = this.clientForm.controls['name'].value;
      client.licenseTierId = this.licenseTierId;
      if (this.clientForm.controls['expiryDate'].value !== null) {
        client.expiryDate = new Date(this.clientForm.controls['expiryDate'].value).toLocaleDateString();
      }
      client.typeFormActivated = this.clientForm.controls['allowImportTypeForm'].value;
      client.typeFormToken = this.clientForm.controls['typeFormToken'].value;
      client.surveyMonkeyActivated = this.clientForm.controls['surveyMonkeyActivated'].value;
      client.surveyMonkeyToken = this.clientForm.controls['surveyMonkeyToken'].value;
      this.clientsService.save(client).subscribe(
        (response) => {
          this.router.navigate(['/clients']);
        },
        (error) => {
        }
      );
    }
  }

  onCancel() {
    this.router.navigate(['/clients']);
  }

  updateLicenseTier(e: any) {
    this.isLicenseTierInternal = e.name === ClientEnum.INTERNAL;
    if (this.isLicenseTierInternal) {
      this.clientForm.controls['active'].setValue(true);
      this.clientForm.controls['name'].setValue(ClientEnum.INTERNAL);
    } else {
      if (this.clientForm.controls['name'].value === ClientEnum.INTERNAL) {
        this.clientForm.controls['name'].setValue('');
      }
    }

    this.licenseTierId = e.id
    this.isAllowImportSurveyMonkey = e.allowImportSurveyMonkey;
    this.isAllowImportTypeForm = e.allowImportTypeForm;
    if (this.isAllowImportTypeForm && this.clientForm.get('allowImportTypeForm').value) {
        this.clientForm.controls['typeFormToken'].setValidators([Validators.required, Validators.maxLength(255)]);
        this.clientForm.controls['typeFormToken'].enable({ emitEvent: false });
    } else {
        this.clientForm.controls['typeFormToken'].clearValidators();
        this.clientForm.controls['typeFormToken'].disable({ emitEvent: false });
    }
    this.clientForm.controls['typeFormToken'].updateValueAndValidity();

    if (this.isAllowImportSurveyMonkey && this.clientForm.get('surveyMonkeyActivated').value) {
        this.clientForm.controls['surveyMonkeyToken'].setValidators([Validators.required, Validators.maxLength(255)]);
        this.clientForm.controls['surveyMonkeyToken'].enable({ emitEvent: false });
    } else {
        this.clientForm.controls['surveyMonkeyToken'].clearValidators();
        this.clientForm.controls['surveyMonkeyToken'].disable({ emitEvent: false });
    }
    this.clientForm.controls['surveyMonkeyToken'].updateValueAndValidity();
  }

  onKeyupClientName(e: any) {
    if (e.target.value !== '') {
        this.clientsService.getClientName(e.target.value, null).subscribe(res => {
            if (res !== null) {
                this.clientForm.controls['name'].setErrors({'existing': true})
            }
        }, err => {
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/clients/new-client/new-client.component.ts